const inMinutes = (minutes) => new Date(Date.now() + minutes * 60 * 1000).toISOString();
const inSeconds = (seconds) => new Date(Date.now() + seconds * 1000).toISOString();
const inDays = (days) => new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString();
const RESERVATION_WINDOW_MINUTES = 2;

let mockCampaigns = [
  {
    uuid: "mock-campaign-summer-savings",
    title: "Summer Savings Ticket Drop",
    description:
      "Reserve a limited coupon ticket for participating local stores and finish payment before the timer expires.",
    status: "AVAILABLE",
    image_url:
      "https://images.unsplash.com/photo-1607083206869-4c7672e72a8a?auto=format&fit=crop&w=640&q=70",
    available_tickets: 42,
    total_tickets: 100,
    ends_at: inDays(8),
  },
  {
    uuid: "mock-campaign-weekend-dining",
    title: "Weekend Dining Rewards",
    description:
      "Book one dining ticket for this campaign. Failed payment can be retried while your reservation is active.",
    status: "RESERVED",
    image_url:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=640&q=70",
    available_tickets: 11,
    total_tickets: 50,
    reservation_expires_at: inSeconds(45),
    ends_at: inDays(3),
    user_ticket: {
      status: "reserved",
      ticket_uuid: "mock-ticket-weekend-dining",
    },
    ticket_code: "WD-1042",
  },
  {
    uuid: "mock-campaign-family-fun",
    title: "Family Fun Pass",
    description:
      "A campaign ticket for family entertainment offers. One redeemed ticket is allowed per user.",
    status: "REDEEMED",
    image_url:
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=640&q=70",
    available_tickets: 5,
    total_tickets: 25,
    redeemed_at: new Date(Date.now() - 2 * 24 * 60 * 60 * 1000).toISOString(),
    ends_at: inDays(12),
    ticket_uuid: "mock-ticket-family-fun",
    user_ticket: {
      status: "booked",
      ticket_uuid: "mock-ticket-family-fun",
    },
    ticket_code: "FF-2388",
    booking_id: "BK-FF-2388",
  },
  {
    uuid: "mock-campaign-grocery-bonus",
    title: "Grocery Bonus Coupon",
    description:
      "Reserve a grocery coupon ticket and complete purchase confirmation to permanently book it.",
    status: "AVAILABLE",
    image_url:
      "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=640&q=70",
    available_tickets: 18,
    total_tickets: 75,
    ends_at: inDays(5),
  },
];

const clone = (value) => JSON.parse(JSON.stringify(value));

const releaseExpiredReservations = () => {
  const now = Date.now();

  mockCampaigns = mockCampaigns.map((campaign) => {
    if (
      campaign.status !== "RESERVED" ||
      !campaign.reservation_expires_at ||
      new Date(campaign.reservation_expires_at).getTime() > now
    ) {
      return campaign;
    }

    return {
      ...campaign,
      status: "AVAILABLE",
      reservation_expires_at: undefined,
      reserved_at: undefined,
      user_ticket: undefined,
      ticket_code: undefined,
    };
  });
};

const findCampaign = (campaignUuid) =>
  mockCampaigns.find((campaign) => campaign.uuid === campaignUuid);

export const getMockActiveCampaigns = (limit = 5) => {
  releaseExpiredReservations();
  const activeCampaigns = mockCampaigns.filter((campaign) => campaign.status !== "EXPIRED");

  return {
    data: clone(activeCampaigns.slice(0, limit)),
    count: activeCampaigns.length,
    source: "mock",
  };
};

export const getMockCampaigns = () => {
  releaseExpiredReservations();

  return {
    data: clone(mockCampaigns),
    count: mockCampaigns.length,
    source: "mock",
  };
};

export const getMockCampaignDetail = (campaignUuid) => {
  releaseExpiredReservations();

  return {
    data: clone(findCampaign(campaignUuid) || mockCampaigns[0]),
    source: "mock",
  };
};

export const reserveMockCampaignTicket = (campaignUuid) => {
  releaseExpiredReservations();
  const campaign = findCampaign(campaignUuid);
  if (!campaign) throw new Error("Campaign not found.");
  if (campaign.status === "REDEEMED") {
    throw new Error("You have already booked a ticket in this campaign.");
  }

  campaign.status = "RESERVED";
  campaign.reserved_at = new Date().toISOString();
  campaign.reservation_expires_at = inMinutes(RESERVATION_WINDOW_MINUTES);
  campaign.ticket_uuid = campaign.ticket_uuid || `mock-ticket-${campaign.uuid}`;
  campaign.user_ticket = {
    status: "reserved",
    ticket_uuid: campaign.ticket_uuid,
  };
  campaign.ticket_code = campaign.ticket_code || `MM-${Math.floor(1000 + Math.random() * 9000)}`;

  return {
    data: clone(campaign),
    message: `Mock ticket reserved for ${RESERVATION_WINDOW_MINUTES} minutes.`,
    source: "mock",
  };
};

export const retryMockCampaignPayment = (campaignUuid) => {
  releaseExpiredReservations();
  const campaign = findCampaign(campaignUuid);
  if (!campaign) throw new Error("Campaign not found.");
  if (campaign.status !== "RESERVED") {
    throw new Error("Only active reservations can retry payment.");
  }

  return {
    data: clone(campaign),
    message: "Mock payment retry started.",
    source: "mock",
  };
};

export const getMockUserTickets = () => {
  releaseExpiredReservations();
  const tickets = mockCampaigns.filter((campaign) =>
    ["RESERVED", "REDEEMED", "EXPIRED"].includes(campaign.status),
  );

  return {
    data: clone(tickets),
    count: tickets.length,
    source: "mock",
  };
};
